var updateBulletinDisplay = (shouldDisplay) => {
    return dispatch => {
        //var winref = window.open('', 'BulletinWindow', '', true);
        //console.log(winref);
        //winref.close();
       
        dispatch(setBulletinDisplay({ 'shouldDisplay': shouldDisplay }));
    }
}

var allowAutoWindowClose = (windowAutoClose) => {
    return dispatch => {
        dispatch(setWindowAutoClose({ 'windowAutoClose': windowAutoClose }));
    }
}

const setWindowAutoClose = postObj => ({
    type: 'ALLOW_WINDOW_AUTO_CLOSE',
    payload: postObj
})

const setBulletinDisplay = postObj => ({
    type: 'SET_BULLETIN',
    payload: postObj
})

var updateUserDisplay = (shouldDisplay) => {
    return dispatch => {
        dispatch(setUserDisplay({ 'shouldDisplay': shouldDisplay }));
    }
}

const setUserDisplay = postObj => ({
    type: 'SET_USER_MANAGER',
    payload: postObj
})

var updateChatDisplay = (shouldDisplay) => {
    return dispatch => {
        dispatch(setChatDisplay({ 'shouldDisplay': shouldDisplay }));
    }
}

const setChatDisplay = postObj => ({
    type: 'SET_CHAT_DISPLAY',
    payload: postObj
})

var updateIconFlash = (shouldTurnFlashOn) => {
    return dispatch => {
        dispatch(setIconFlash({ 'shouldTurnFlashOn': shouldTurnFlashOn }));
    }
}

const setIconFlash = postObj => ({
    type: 'SET_ICON_FLASH',
    payload: postObj
})

var updateGroupDisplay = (shouldDisplay) => {
    return dispatch => {
        dispatch(setGroupDisplay({ 'shouldDisplay': shouldDisplay }));
    }
}

const setGroupDisplay = postObj => ({
    type: 'SET_GROUP_MANAGER',
    payload: postObj
})

export default {
    'SET_BULLETIN': updateBulletinDisplay,
    'SET_USER_MANAGER': updateUserDisplay,
    'SET_GROUP_MANAGER': updateGroupDisplay,
    'SET_CHAT_DISPLAY': updateChatDisplay,
    'SET_ICON_FLASH': updateIconFlash,
    'ALLOW_WINDOW_AUTO_CLOSE': allowAutoWindowClose
};


// WEBPACK FOOTER //
// ./src/actions/window_actions.js


// WEBPACK FOOTER //
// ./src/actions/window_actions.js